import { createSlice } from "@reduxjs/toolkit";

//Initial Value of Slice
const initialState = {
    List: [
        {
            Id : "Primary-1",
        }
    ]
}

//Action of Slice
const CanFaqSlice = createSlice({
    name: "CanFaq",
    initialState,
    reducers: {}
})

//Export of Slice
export const { } = CanFaqSlice.actions;
export default CanFaqSlice.reducer;